import "../assets/index-4596132f.css";
import l from "./NcButton.mjs";
import { t as p } from "../chunks/l10n-1b905a9a.mjs";
import "../Directives/Tooltip.mjs";
import { emit as n } from "@nextcloud/event-bus";
import { A as r } from "../chunks/ArrowRight-74a9fcb2.mjs";
import { n as o } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
import { VTooltip as c } from "floating-vue";
import { useIsMobile as u } from "../Composables/useIsMobile.mjs";
import { getBuilder as f } from "@nextcloud/browser-storage";
import { useSwipe as h } from "@vueuse/core";
import { Pane as g, Splitpanes as d } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
const m = {
  name: "NcAppDetailsToggle",
  directives: {
    tooltip: c
  },
  components: {
    NcButton: l,
    ArrowRight: r
  },
  computed: {
    title() {
      return p("Go back to the list");
    }
  },
  beforeMount() {
    this.toggleAppNavigationButton(!0);
  },
  beforeDestroy() {
    this.toggleAppNavigationButton(!1);
  },
  methods: {
    toggleAppNavigationButton(e = !0) {
      const t = document.querySelector(".app-navigation .app-navigation-toggle");
      t && (t.style.display = e ? "none" : null, e === !0 && n("toggle-navigation", { open: !1 }));
    }
  }
};
var _ = function() {
  var t = this, i = t._self._c;
  return i("NcButton", { directives: [{ name: "tooltip", rawName: "v-tooltip", value: t.title, expression: "title" }], staticClass: "app-details-toggle", attrs: { "aria-label": t.title }, scopedSlots: t._u([{ key: "icon", fn: function() {
    return [i("ArrowRight", { attrs: { size: 20 } })];
  }, proxy: !0 }]) });
}, z = [], S = /* @__PURE__ */ o(
  m,
  _,
  z,
  !1,
  null,
  "5244e83e",
  null,
  null
);
const v = S.exports;
const a = f("nextcloud").persist().build(), w = {
  name: "NcAppContent",
  components: {
    NcAppDetailsToggle: v,
    Pane: g,
    Splitpanes: d
  },
  props: {
    /**
     * Allows to disable the control by swipe of the app navigation open state
     */
    allowSwipeNavigation: {
      type: Boolean,
      default: !0
    },
    /**
     * Allows you to set the default width of the resizable list in %
     * Must be between listMinWidth and listMaxWidth
     */
    listSize: {
      type: Number,
      default: 20
    },
    /**
     * Allows you to set the minimum width of the list column in %
     */
    listMinWidth: {
      type: Number,
      default: 15
    },
    /**
     * Allows you to set the maximum width of the list column in %
     */
    listMaxWidth: {
      type: Number,
      default: 40
    },
    /**
     * Specify the config key for the pane config sizes
     * Default is the global var appName if you use the webpack-vue-config
     */
    paneConfigKey: {
      type: String,
      default: ""
    },
    /**
     * When in mobile view, only the list or the details are shown
     * If you provide a list, you need to provide a variable
     * that will be set to true by the user when an element of
     * the list gets selected. The details will then show a back
     * arrow to return to the list that will update this prop to false.
     */
    showDetails: {
      type: Boolean,
      default: !0
    },
    /**
     * Specify the `<h1>` page heading
     */
    pageHeading: {
      type: String,
      default: null
    }
  },
  emits: [
    "update:showDetails",
    "resize:list"
  ],
  setup() {
    return {
      isMobile: u()
    };
  },
  data() {
    return {
      contentHeight: 0,
      hasList: !1,
      swiping: {},
      listPaneSize: this.restorePaneConfig()
    };
  },
  computed: {
    paneConfigID() {
      if (this.paneConfigKey !== "")
        return `pane-list-size-${this.paneConfigKey}`;
      try {
        return `pane-list-size-${appName}`;
      } catch {
        return console.info("[INFO] AppContent:", "falling back to global nextcloud pane config"), "pane-list-size-nextcloud";
      }
    },
    detailsPaneSize() {
      return this.listPaneSize ? 100 - this.listPaneSize : this.paneDefaults.details.size;
    },
    paneDefaults() {
      return {
        list: {
          size: this.listSize,
          min: this.listMinWidth,
          max: this.listMaxWidth
        },
        // set the inverse values of the details column
        // based on the provided (or default) values of the list column
        details: {
          size: 100 - this.listSize,
          min: 100 - this.listMaxWidth,
          max: 100 - this.listMinWidth
        }
      };
    }
  },
  updated() {
    this.checkListSlot();
  },
  mounted() {
    this.allowSwipeNavigation && (this.swiping = h(this.$el, {
      onSwipeEnd: this.handleSwipe
    })), this.checkListSlot(), this.restorePaneConfig();
  },
  methods: {
    /**
     * handle the swipe event
     *
     * @param {TouchEvent} e The touch event
     * @param {import('@vueuse/core').SwipeDirection} direction The swipe direction of the event
     */
    handleSwipe(e, t) {
      Math.abs(this.swiping.lengthX) > 70 && (this.swiping.coordsStart.x < 300 / 2 && t === "right" ? n("toggle-navigation", {
        open: !0
      }) : this.swiping.coordsStart.x < 300 * 1.5 && t === "left" && n("toggle-navigation", {
        open: !1
      }));
    },
    handlePaneResize(e) {
      const t = parseInt(e[0].size, 10);
      a.setItem(this.paneConfigID, JSON.stringify(t)), this.listPaneSize = t, this.$emit("resize:list", { size: t }), console.debug("AppContent pane config", t);
    },
    // $slots is not reactive, we need to update this manually
    checkListSlot() {
      const e = !!this.$slots.list;
      this.hasList !== e && (this.hasList = e);
    },
    // browserStorage is not reactive, we need to update this manually
    restorePaneConfig() {
      const e = parseInt(a.getItem(this.paneConfigID), 10);
      if (!isNaN(e) && e !== this.listPaneSize)
        return console.debug("AppContent pane config", e), this.listPaneSize = e, e;
    },
    /**
     * The user clicked the back arrow from the details view
     */
    hideDetails() {
      this.$emit("update:showDetails", !1);
    }
  }
};
var y = function() {
  var t = this, i = t._self._c;
  return i("main", { staticClass: "app-content no-snapper", class: { "app-content--has-list": t.hasList }, attrs: { id: "app-content-vue" } }, [t.pageHeading ? i("h1", { staticClass: "hidden-visually" }, [t._v(" " + t._s(t.pageHeading) + " ")]) : t._e(), t.hasList ? [t.isMobile ? i("div", { staticClass: "app-content-wrapper app-content-wrapper--mobile", class: t.showDetails ? "app-content-wrapper--show-details" : "app-content-wrapper--show-list" }, [t.hasList && t.showDetails ? i("NcAppDetailsToggle", { nativeOn: { click: function(s) {
    return s.stopPropagation(), s.preventDefault(), t.hideDetails.apply(null, arguments);
  } } }) : t._e(), t._t("list"), t._t("default")], 2) : i("div", { staticClass: "app-content-wrapper" }, [i("Splitpanes", { staticClass: "default-theme", on: { resized: t.handlePaneResize } }, [i("Pane", { staticClass: "splitpanes__pane-list", attrs: { size: t.listPaneSize || t.paneDefaults.list.size, "min-size": t.paneDefaults.list.min, "max-size": t.paneDefaults.list.max } }, [t._t("list")], 2), i("Pane", { staticClass: "splitpanes__pane-details", attrs: { size: t.detailsPaneSize, "min-size": t.paneDefaults.details.min, "max-size": t.paneDefaults.details.max } }, [t._t("default")], 2)], 1)], 1)] : t._t("default")], 2);
}, C = [], N = /* @__PURE__ */ o(
  w,
  y,
  C,
  !1,
  null,
  "27fc3f3a",
  null,
  null
);
const W = N.exports;
export {
  W as default
};
